<div class="text-left filter-bar">

  <p-multiSelect [options]="countries | async" [(ngModel)]="filter.countries"
                 defaultLabel="Country/Territory"
                 dropdownIcon="fa fa-chevron-down"
                 [maxSelectedLabels]="0"
                 selectedItemsLabel="Country/Territory ({0})"
                 [filter]="true"
                 (onChange)="change()"
                 class="padding-left">
  </p-multiSelect>

  <p-multiSelect [options]="regions | async" [(ngModel)]="filter.regions"
                 defaultLabel="Region"
                 dropdownIcon="fa fa-chevron-down"
                 [maxSelectedLabels]="0"
                 selectedItemsLabel="Region ({0})"
                 [filter]="true"
                 (onChange)="change()">
  </p-multiSelect>

  <p-multiSelect [options]="organizations | async" [(ngModel)]="filter.organizations"
                 defaultLabel="Organization"
                 dropdownIcon="fa fa-chevron-down"
                 [maxSelectedLabels]="0"
                 selectedItemsLabel="Organization ({0})"
                 [filter]="true"
                 (onChange)="change()">
  </p-multiSelect>

  <p-multiSelect *ngIf="isAuthenticated"
                 [options]="titles | async" [(ngModel)]="filter.titles"
                 defaultLabel="Appointment title"
                 dropdownIcon="fa fa-chevron-down"
                 [maxSelectedLabels]="0"
                 selectedItemsLabel="Appointment title ({0})"
                 [filter]="true"
                 (onChange)="change()">
  </p-multiSelect>

  <p-multiSelect *ngIf="isAuthenticated"
                 [options]="areas | async" [(ngModel)]="filter.areas"
                 defaultLabel="Area of expertise"
                 dropdownIcon="fa fa-chevron-down"
                 [maxSelectedLabels]="0"
                 selectedItemsLabel="Area of expertise ({0})"
                 [filter]="true"
                 (onChange)="change()">
  </p-multiSelect>

</div>

<div>
  <p-checkbox *ngIf="isAuthenticated"
              [binary]="true"
              [label]="'DASHBOARD.OFFICIAL_CONTACT' | translate"
              (onChange)="change()"
              [(ngModel)]="filter.officialNso">
  </p-checkbox>
</div>
